export default {
  brand_name: 'USFans Spreadsheet',
  nav_spreadsheet: 'Hoja de cálculo',
  nav_guides: 'Guías',
  nav_reviews: 'Reseñas',
  nav_shipping: 'Envío',
  nav_safety: 'Seguridad',
  nav_faq: 'Preguntas',
  nav_mainWebsite: 'Sitio principal',
  nav_home: 'Inicio',
  nav_shoppingGuide: 'Guía de compras',
  nav_browseCategories: 'Explorar categorías',
  read_more: 'Leer más',
};